import { Box, Typography } from "@mui/material";
import { AdminQueryMessage } from "src/utils/api/adminQuery";

interface Props {
  message: AdminQueryMessage;
  isMine: boolean;
}

const formatTime = (iso: string) => {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
};

const senderLabel = (m: AdminQueryMessage, isMine: boolean) => {
  if (isMine) return "You";
  const fn = m.sender?.firstName?.trim();
  const ln = m.sender?.lastName?.trim();
  const name = [fn, ln].filter(Boolean).join(" ");
  return name || m.sender?.email || "User";
};

const MessageBubble = ({ message, isMine }: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isMine ? "flex-end" : "flex-start",
        mb: 1.5,
      }}
    >
      <Box
        sx={{
          maxWidth: "70%",
          bgcolor: isMine ? "primary.main" : "grey.200",
          color: isMine ? "primary.contrastText" : "text.primary",
          borderRadius: 2,
          px: 2,
          py: 1,
        }}
      >
        <Typography
          variant="caption"
          sx={{ display: "block", opacity: 0.85, fontWeight: 600 }}
        >
          {senderLabel(message, isMine)}
        </Typography>
        <Typography
          variant="body2"
          sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {message.message}
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: "block", opacity: 0.7, mt: 0.5 }}
        >
          {formatTime(message.createdAt)}
        </Typography>
      </Box>
    </Box>
  );
};

export default MessageBubble;
